import { AxiosError, AxiosResponse } from "axios";
import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "src/contexts/AuthContext";
import { CreateAssociationV2 } from "../../actions/CreateAssociationV2";
import { GetErrorPageUrl } from "../../actions/GetErrorPageUrl";
import { Loading } from "../../components";
import { ErrorResponse } from "../../hooks/errorReponse";
import {
  integratorCallback,
  IntegratorCallbackResponse,
  IntegratorCallbackResponseError,
  PROVIDER_ERROR_CODE
} from "../../hooks/integrator";
import { useQueryParams } from "../../hooks/queryParams";
import { captureException } from "@sentry/react";

const Callback = () => {
  const { authenticate, user } = useContext(AuthContext);
  useEffect(() => {
    authenticate();
  }, []);

  const queryParams = useQueryParams();
  const code: string = queryParams.get("code") || "";
  const state: string = queryParams.get("state") || "";
  const params: any = getParams(queryParams);
  const navigate = useNavigate();

  handleParams(params, queryParams);

  useEffect(() => {
    if (!user) return;

    if (code !== "") {
      const providerOTP = localStorage.getItem("providerOTP");
      if (providerOTP === code) {
        const url = localStorage.getItem("alfUrlInit");
        if (url != null) {
          navigate(url, { replace: true });
          return;
        }

        navigate(GetErrorPageUrl(), { replace: true });
        return;
      }

      localStorage.setItem("providerOTP", code);
    }

    integratorCallback(code, state, undefined, undefined, params)
      .then((response: AxiosResponse<IntegratorCallbackResponse>) => {
        const data = response.data;

        localStorage.setItem("userId", data.userId);
        localStorage.setItem("providerId", data.providerId);
        localStorage.setItem("state", data.state);

        if (data.isNewIntegration) {
          CreateAssociationV2()
            .then(association => {
              navigate(`/v2/terms?code=${association.code}`, { replace: true });
            })
            .catch((error: ErrorResponse) => {
              navigate(GetErrorPageUrl(error), { replace: true });
            });
        } else {
          navigate("/terms", { replace: true });
        }
      })
      .catch((error: AxiosError<IntegratorCallbackResponseError>) => {
        captureException(new Error(`Callback response error: ${error}`));
        if (
          error.response?.data.code ||
          error.response?.status === PROVIDER_ERROR_CODE
        ) {
          navigate(GetErrorPageUrl(error.response.data), { replace: true });
        } else {
          const errorId = error.response?.data.errorId ?? "";
          navigate(GetErrorPageUrl({ code: 100, errorId }), { replace: true });
        }
      });
  }, [user]);

  return <Loading />;
};

const getParams = (queryParams: URLSearchParams): object => {
  try {
    return JSON.parse(queryParams.get("params") || "{}");
  } catch (e) {
    return {};
  }
};

const handleParams = (params: any, queryParams: any): void => {
  const allowedParams = [
    "access_token",
    "uid",
    "nome",
    "email",
    "oauth_consumer_key",
    "oauth_nonce",
    "oauth_signature_method",
    "oauth_timestamp",
    "oauth_token",
    "oauth_version",
    "oauth_signature",
    "ss",
    "codigo_cliente"
  ];

  allowedParams.forEach(p => {
    const value: string | null = queryParams.get(p) || null;
    if (value) {
      params[p] = value;
    }
  });
};

export default Callback;
